import { render, staticRenderFns } from "./payments-history-modal.vue?vue&type=template&id=4546d871&"
import script from "./payments-history-modal.vue?vue&type=script&lang=js&"
export * from "./payments-history-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports